module.exports = __webpack_public_path__ + "img/u1142_div.269cac86.png";